"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CampaignListItem;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _uiKit = require("@devsta/ui-kit");

var _getUserFullName = _interopRequireDefault(require("@devsta/get-user-full-name"));

var _OrderChanger = _interopRequireDefault(require("./OrderChanger"));

require("../styles/_campaign-list-item.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function withNoEventPropagation(fn) {
  return function (e) {
    e.preventDefault();
    e.stopPropagation();
    fn();
  };
}

var getDateTime = function getDateTime(date) {
  return (0, _moment.default)(date, 'x').format('DD MMM YYYY [at] hh:mm A');
};

function CampaignListItem(_ref) {
  var onChangeOrder = _ref.onChangeOrder,
      numberOfItems = _ref.numberOfItems,
      updateCampaign = _ref.updateCampaign,
      editCampaign = _ref.editCampaign,
      deleteCampaign = _ref.deleteCampaign,
      history = _ref.history,
      movingCampaign = _ref.movingCampaign;
  return function (campaign, index) {
    var actionOptions = [{
      action: withNoEventPropagation(function () {
        return history.push("/manage/campaigns/".concat(campaign.inspirationCampaignId));
      }),
      label: 'View Campaign'
    }, {
      action: withNoEventPropagation(function () {
        return editCampaign(campaign);
      }),
      label: 'Modify Campaign'
    }, !campaign.isActive ? {
      action: withNoEventPropagation(deleteCampaign(campaign)),
      label: 'Delete Campaign',
      isRed: true
    } : void 0].filter(Boolean);
    var inspirationCampaignId = campaign.inspirationCampaignId,
        coverImageKey = campaign.coverImageKey,
        name = campaign.name,
        description = campaign.description,
        updatedAt = campaign.updatedAt,
        updatedByUser = campaign.updatedByUser,
        isActive = campaign.isActive;
    return _react.default.createElement(_uiKit.List.ListItem, {
      key: inspirationCampaignId,
      className: "campaign-list-item",
      hideImage: true,
      onClick: function onClick() {
        return history.push("/manage/campaigns/".concat(campaign.inspirationCampaignId));
      }
    }, onChangeOrder && numberOfItems && numberOfItems > 1 && _react.default.createElement(_OrderChanger.default, {
      currentIndex: index,
      numberOfItems: numberOfItems,
      onChangeOrder: onChangeOrder,
      disabled: movingCampaign
    }), _react.default.createElement(_uiKit.Image, {
      defaultImageIcon: "guide",
      height: "100px",
      width: "100px",
      borderRadius: 6,
      defaultIconColour: "russian",
      imageUrl: coverImageKey,
      backgroundSize: "cover"
    }), _react.default.createElement("div", {
      className: "campaign-list-item__details"
    }, _react.default.createElement("div", {
      className: "campaign-list-item__details__right-content"
    }, _react.default.createElement(_uiKit.Text, {
      heading5: true,
      noMargin: true
    }, name), description && _react.default.createElement(_uiKit.Text, {
      caption: true,
      noMargin: true
    }, description))), updatedByUser && _react.default.createElement(_uiKit.List.ListItem.UserDetails, {
      userName: (0, _getUserFullName.default)(updatedByUser),
      profileImage: updatedByUser.imageUrl
    }, _react.default.createElement(_uiKit.Text, {
      noMargin: true,
      label: true
    }, updatedByUser.jobTitle)), _react.default.createElement("div", {
      className: "campaign-list-item__date"
    }, _react.default.createElement(_uiKit.Text, {
      noMargin: true
    }, getDateTime(updatedAt)), _react.default.createElement(_uiKit.Text, {
      caption: true,
      noMargin: true,
      className: "campaign-list-item__user-role"
    }, "Last Updated")), _react.default.createElement(_uiKit.Button, {
      type: isActive ? 'SECONDARY' : void 0,
      className: "campaign-list-item__publish-btn",
      onClick: withNoEventPropagation(updateCampaign({
        inspirationCampaignId: inspirationCampaignId,
        isActive: !isActive,
        permissions: campaign.permissions
      }))
    }, "".concat(isActive ? 'Pause' : 'Start', " Campaign")), _react.default.createElement(_uiKit.ActionPopup, {
      options: actionOptions
    }));
  };
}